import {clearPagination} from 'core/helpers/pagination';
import {useRouter} from 'next/router';
import {useCallback, useState} from 'react';

interface IProps {
    page: number;
}

export const usePageChange = ({page}: IProps) => {
    const [currentPage, setCurrentPage] = useState(Number(page) || 0);
    const {asPath, replace} = useRouter();

    const onPageChange = useCallback(
        (pageNumber: number) => {
            setCurrentPage(pageNumber);

            if (1 === pageNumber) {
                const clearedPath = clearPagination(asPath);
                return replace(clearedPath);
            }

            if (asPath.match(/page/gu)) {
                const clearedPath = clearPagination(asPath);
                return replace(`${clearedPath}page${pageNumber}`);
            }

            return replace(`${asPath}/page${pageNumber}`);
        },
        [asPath, replace],
    );

    const onControlPageChange = useCallback(
        (pageNumber: number, isShallow: boolean = false) => {
            setCurrentPage(pageNumber);

            if (1 === pageNumber) {
                const clearedPath = clearPagination(asPath);
                return replace(clearedPath, undefined, {shallow: isShallow});
            }

            if (asPath.match(/page/gu)) {
                const clearedPath = clearPagination(asPath);
                return replace(`${clearedPath}page${pageNumber}`, undefined, {shallow: isShallow});
            }

            return replace(`${asPath}/page${pageNumber}`, undefined, {shallow: isShallow});
        },
        [asPath, replace],
    );

    return {currentPage, onControlPageChange, onPageChange};
};
